export const DAY_STATUS = {
  BLOCKED: "BLOCKED",//full day blocked
  PARTIALLY: "PARTIALLY_BLOCKED",
  AVAILABLE: "AVAILABLE",//no day selected, or empty say
}